'use strict';

(function () {
    $(document).on(Fotobook.events.AJAX_DONE, (event, result, response) => {
        if (response.message) {
            Fotobook.notification.showMessage(Fotobook.notification.statuses[response.status], response.message);
        }
        if (response.flashes) {
            Fotobook.notification.showMessages(response.flashes);
        }
    });
})();
